import { render, staticRenderFns } from "./InventoryLabResultUpload.vue?vue&type=template&id=0da4d8d0&scoped=true"
import script from "./InventoryLabResultUpload.vue?vue&type=script&lang=js"
export * from "./InventoryLabResultUpload.vue?vue&type=script&lang=js"
import style0 from "./InventoryLabResultUpload.vue?vue&type=style&index=0&id=0da4d8d0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da4d8d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da4d8d0')) {
      api.createRecord('0da4d8d0', component.options)
    } else {
      api.reload('0da4d8d0', component.options)
    }
    module.hot.accept("./InventoryLabResultUpload.vue?vue&type=template&id=0da4d8d0&scoped=true", function () {
      api.rerender('0da4d8d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryLabResult/InventoryLabResultUpload.vue"
export default component.exports